/* eslint-disable react-hooks/exhaustive-deps */

import { CURRENCY_LABEL_FORMATS, getCurrencyOptions } from 'modules/enumerations/enumerationHelpers';
import {
  Grid,
} from '@mui/material';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { findPartnerName, partnerSearchInfo } from 'modules/common/partnerSearchInfo';
import { showToast } from 'modules/layout/layout.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';
import {
  getAuthDestinationServices,
  updateAuthDestinationServicesRenter,
} from 'modules/authorizations/store/actions/destinationService.actions';
export const ZERO_GUID = '00000000-0000-0000-0000-000000000000';

const RenterPreferencesCard = (props) => {
    const { renterDetails, fileServices, vendors: partners, authId, hideEdit, enumerations } = props;

  const [isLoading, setIsLoading] = useState(false);
    const isFailure = r => r?.type?.endsWith('_FAILURE');


  let renterCardInfo = {
    serviceInitiationDate: renterDetails?.renter?.serviceInitiationDate ?? fileServices.addedOn,
    dateNeeded: renterDetails?.renter?.dateNeeded ?? null,
    payInCurrencyId: renterDetails?.renter?.payInCurrencyId ?? '',
    priceRangeMin: renterDetails?.renter?.priceRangeMin ?? 0,
    priceRangeMax: renterDetails?.renter?.priceRangeMax ?? 0,
    numBedrooms: renterDetails?.renter?.numBedrooms ?? 0,
    numBathrooms: renterDetails?.renter?.numBathrooms ?? 0,
    schoolRequest: renterDetails?.renter?.schoolRequest ?? false,
    schoolRequestNote: renterDetails?.renter?.schoolRequestNote ?? '',
    hasRentalSecured: renterDetails?.renter?.hasRentalSecured ?? false,
    leaseStartDate: renterDetails?.renter?.leaseStartDate ?? null,
    leaseEndDate: renterDetails?.renter?.leaseEndDate ?? null,
    leaseAmount: renterDetails?.renter?.leaseAmount ?? '',
    specialNeeds: renterDetails?.renter?.specialNeeds ?? '',
    requestAreaTour: Boolean(renterDetails?.areaTourInfo?.areaTourId),
    areaTourAgentId: renterDetails?.areaTourInfo?.areaTourAgentId ?? '',
    areaTourInitiationDate: renterDetails?.areaTourInfo?.areaTourInitiationDate ?? null,
    areaTourCanceledDate: renterDetails?.areaTourInfo?.areaTourCanceledDate ?? null,
    areaTourCompletedDate: renterDetails?.areaTourInfo?.areaTourCompletedDate ?? null,
  };

  const renterPreferencesTabs = [
    { header: 'Renter Preferences', order: 1, iconPath: ['fas', 'fa-truck-moving'] },
  ];

    // The Area Tour Agent field is sourced from partners (vendors on the API); areaTourAgentId holds the selected partner's vendorId.
    const areaTourPartnerSearchInfo = partnerSearchInfo(partners);

  const renterPreferencesSummaries = [
    {
          header: 'Service Start Date',
          accessorKey: 'serviceInitiationDate',
          type: 'date',
          required: false,
          value: renterCardInfo?.serviceInitiationDate || null,
          tab: 1,
          hideInModal: true
    },
    { header: 'Date Needed', accessorKey: 'dateNeeded', type: 'date', required: false, value: renterCardInfo?.dateNeeded || null, tab: 1 },
    { header: 'Currency', accessorKey: 'payInCurrencyId', type: 'dropdown-v2', required: false, value: renterCardInfo ? renterCardInfo.payInCurrencyId : '', options: getCurrencyOptions(enumerations?.currencies, CURRENCY_LABEL_FORMATS.LONG), tab: 1 },
    { header: 'Min Price', accessorKey: 'priceRangeMin', type: 'money', required: false, value: renterCardInfo ? renterCardInfo.priceRangeMin : '', tab: 1 },
    { header: 'Max Price', accessorKey: 'priceRangeMax', type: 'money', required: false, value: renterCardInfo ? renterCardInfo.priceRangeMax : '', tab: 1 },
    { header: 'Bedroom Preference', accessorKey: 'numBedrooms', type: 'number', required: false, value: renterCardInfo ? renterCardInfo.numBedrooms : 0, tab: 1 },
    { header: 'Bathroom Preference', accessorKey: 'numBathrooms', type: 'number', required: false, value: renterCardInfo ? renterCardInfo.numBathrooms : 0, tab: 1 },
    { header: 'School Request', accessorKey: 'schoolRequest', type: 'checkbox', required: false, value: renterCardInfo ? renterCardInfo.schoolRequest : false, tab: 1 },
    { header: 'School Request Note', accessorKey: 'schoolRequestNote', type: 'text', required: false, value: renterCardInfo ? renterCardInfo.schoolRequestNote : '', tab: 1,
        showWhen: () => {
            return renterCardInfo && renterCardInfo.schoolRequest === true;
        },
        showWhenModal: ({ values }) => {
            return values && values.schoolRequest === true;
        }
     },
    { header: 'Rental Secured', accessorKey: 'hasRentalSecured', type: 'checkbox', required: false, value: renterCardInfo ? renterCardInfo.hasRentalSecured : false, tab: 1 },
    { header: 'Lease Start Date', accessorKey: 'leaseStartDate', type: 'date', required: false, value: renterCardInfo ? renterCardInfo.leaseStartDate : '', tab: 1,
        showWhen: () => {
            return renterCardInfo && renterCardInfo.hasRentalSecured === true;
        },
        showWhenModal: ({ values }) => {
            return values && values.hasRentalSecured === true;
        }
     },
    { header: 'Lease End Date', accessorKey: 'leaseEndDate', type: 'date', required: false, value: renterCardInfo ? renterCardInfo.leaseEndDate : '', tab: 1,
        showWhen: () => {
            return renterCardInfo && renterCardInfo.hasRentalSecured === true;
        },
        showWhenModal: ({ values }) => {
            return values && values.hasRentalSecured === true;
        }
     },
    { header: 'Lease Amount', accessorKey: 'leaseAmount', type: 'money', required: false, value: renterCardInfo ? renterCardInfo.leaseAmount : '', tab: 1,
        showWhen: () => {
            return renterCardInfo && renterCardInfo.hasRentalSecured === true;
        },
        showWhenModal: ({ values }) => {
            return values && values.hasRentalSecured === true;
        }
     },
    { header: 'Special Needs', accessorKey: 'specialNeeds', type: 'text', required: false, value: renterCardInfo ? renterCardInfo.specialNeeds : '', tab: 1 },
    { dividerLine: true, tab: 1 },
    { header: 'Area Tour', accessorKey: 'requestAreaTour', type: 'checkbox', required: false, value: renterCardInfo ? renterCardInfo.requestAreaTour : false, tab: 1 },
    { header: 'Area Tour Agent', accessorKey: 'areaTourAgentId', type: 'advanced-search', searchInfo: areaTourPartnerSearchInfo, nameKey: 'areaTourPartnerName', nameValue: findPartnerName(partners, renterCardInfo?.areaTourAgentId), required: false, value: renterCardInfo ? renterCardInfo.areaTourAgentId : '', tab: 1,
        showWhen: () => {
            return renterCardInfo && renterCardInfo.requestAreaTour === true;
        },
        showWhenModal: ({ values }) => {
            return values && values.requestAreaTour === true;
        }
     },
    { header: 'Area Tour Initiation Date', accessorKey: 'areaTourInitiationDate', type: 'date', required: false, value: renterCardInfo ? renterCardInfo.areaTourInitiationDate : null, tab: 1, 
        showWhen: () => {
            return renterCardInfo && renterCardInfo.requestAreaTour === true;
        },
        showWhenModal: ({ values }) => {
            return values && values.requestAreaTour === true;
        }
         },
    { header: 'Area Tour Canceled Date', accessorKey: 'areaTourCanceledDate', type: 'date', required: false, value: renterCardInfo ? renterCardInfo.areaTourCanceledDate : null, tab: 1, 
        showWhen: () => {
            return renterCardInfo && renterCardInfo.requestAreaTour === true;
        },
        showWhenModal: ({ values }) => {
            return values && values.requestAreaTour === true;
        }
    },
    { header: 'Area Tour Completion Date', accessorKey: 'areaTourCompletedDate', type: 'date', required: false, value: renterCardInfo ? renterCardInfo.areaTourCompletedDate : null, tab: 1, 
        showWhen: () => {
            return renterCardInfo && renterCardInfo.requestAreaTour === true;
        },
        showWhenModal: ({ values }) => {
            return values && values.requestAreaTour === true;
        }
     },
];
  
  const updateRenterPreferences = async (tab, values) => {
    setIsLoading(true);
    const payload = { ...(renterDetails || {}) };

    if(!renterDetails || !renterDetails.renter) {
        payload.renter = payload.renter || {};
        payload.areaTourInfo = payload.areaTourInfo || {};

        payload.renter.serviceInitiationDate = renterDetails?.renter?.serviceInitiationDate ?? fileServices.addedOn;
        payload.renter.renterServiceId = renterDetails?.renter?.renterServiceId ?? 0;
        payload.renter.authorizationFileId = authId;
        payload.renter.dateNeeded = values.dateNeeded || null;
        payload.renter.payInCurrencyId = !values.payInCurrencyId || values.payInCurrencyId === '' ? ZERO_GUID : values.payInCurrencyId;
        payload.renter.priceRangeMin = values.priceRangeMin === '' || values.priceRangeMin == null ? null : Number(values.priceRangeMin);
        payload.renter.priceRangeMax = values.priceRangeMax === '' || values.priceRangeMax == null ? null : Number(values.priceRangeMax);
        payload.renter.numBedrooms = values.numBedrooms === '' || values.numBedrooms == null ? null : parseInt(values.numBedrooms, 10);
        payload.renter.numBathrooms = values.numBathrooms === '' || values.numBathrooms == null ? null : parseInt(values.numBathrooms, 10);
        payload.renter.leaseAmount = values.leaseAmount === '' || values.leaseAmount == null ? null : Number(values.leaseAmount);
        payload.renter.penaltyDepositAmount = values.pentaltyDepositAmount === '' || values.pentaltyDepositAmount == null ? null : Number(values.pentaltyDepositAmount);
        payload.renter.leaseStartDate = values.leaseStartDate ?? null;
        payload.renter.leaseEndDate = values.leaseEndDate ?? null;
        payload.renter.schoolRequest = values.schoolRequest ?? false;
        payload.renter.schoolRequestNote = values.schoolRequest ? (values.schoolRequestNote ?? '') : '';
        payload.renter.hasRentalSecured = values.hasRentalSecured ?? false;
        payload.renter.specialNeeds = values.specialNeeds ?? '';
        payload.renter.areaTourId = values.requestAreaTour ? renterDetails?.areaTourId : null;
        payload.renter.addedOn = renterDetails ? renterDetails.addedOn : new Date();
        payload.renter.addedBy = 0;
        payload.renter.modifiedOn = new Date();
        payload.renter.modifiedBy = 0;

        payload.areaTourInfo.areaTourId = values.requestAreaTour ? renterDetails?.areaTourId : null;
        payload.areaTourInfo.areaTourInitiationDate = values.requestAreaTour ? values.areaTourInitiationDate : null;
        payload.areaTourInfo.areaTourCanceledDate = values.requestAreaTour ? values.areaTourCanceledDate : null;
        payload.areaTourInfo.areaTourCompletedDate = values.requestAreaTour ? values.areaTourCompletedDate : null;
        payload.areaTourInfo.areaTourAgentId = values.requestAreaTour ? values.areaTourAgentId : 0;
        payload.areaTourInfo.addedOn = renterDetails && renterDetails.areaTourInfo ? renterDetails.areaTourInfo.addedOn : new Date();
        payload.areaTourInfo.addedBy = 0;
        payload.areaTourInfo.modifiedOn = new Date();
        payload.areaTourInfo.modifiedBy = 0;
    }
    else {
        payload.renter = payload.renter || {};
        payload.areaTourInfo = payload.areaTourInfo || {};

        payload.renter.serviceInitiationDate = renterDetails?.renter?.serviceInitiationDate ?? fileServices.addedOn;
        payload.renter.dateNeeded = values.dateNeeded || null;
        payload.renter.payInCurrencyId = !values.payInCurrencyId || values.payInCurrencyId === '' ? ZERO_GUID : values.payInCurrencyId;
        payload.renter.priceRangeMin = values.priceRangeMin === '' || values.priceRangeMin == null ? null : Number(values.priceRangeMin);
        payload.renter.priceRangeMax = values.priceRangeMax === '' || values.priceRangeMax == null ? null : Number(values.priceRangeMax);
        payload.renter.numBedrooms = values.numBedrooms === '' || values.numBedrooms == null ? null : parseInt(values.numBedrooms, 10);
        payload.renter.numBathrooms = values.numBathrooms === '' || values.numBathrooms == null ? null : parseInt(values.numBathrooms, 10);
        payload.renter.leaseAmount = values.leaseAmount === '' || values.leaseAmount == null ? null : Number(values.leaseAmount);
        payload.renter.penaltyDepositAmount = values.pentaltyDepositAmount === '' || values.pentaltyDepositAmount == null ? null : Number(values.pentaltyDepositAmount);
        payload.renter.leaseStartDate = values.leaseStartDate ?? null;
        payload.renter.leaseEndDate = values.leaseEndDate ?? null;
        payload.renter.schoolRequest = values.schoolRequest ?? false;
        payload.renter.schoolRequestNote = values.schoolRequest ? (values.schoolRequestNote ?? '') : '';
        payload.renter.hasRentalSecured = values.hasRentalSecured ?? false;
        payload.renter.specialNeeds = values.specialNeeds ?? '';
        payload.renter.modifiedOn = new Date();
        payload.renter.modifiedBy = 0;

        payload.areaTourInfo.areaTourId = values.requestAreaTour ? renterDetails?.renter.areaTourId : null;
        payload.areaTourInfo.areaTourInitiationDate = values.requestAreaTour ? values.areaTourInitiationDate : null;
        payload.areaTourInfo.areaTourCanceledDate = values.requestAreaTour ? values.areaTourCanceledDate : null;
        payload.areaTourInfo.areaTourCompletedDate = values.requestAreaTour ? values.areaTourCompletedDate : null;
        payload.areaTourInfo.areaTourAgentId = values.requestAreaTour ? values.areaTourAgentId : 0;
        payload.areaTourInfo.addedOn = renterDetails && renterDetails.areaTourInfo ? renterDetails.areaTourInfo.addedOn : new Date();
        payload.areaTourInfo.addedBy = 0;
        payload.areaTourInfo.modifiedOn = new Date();
        payload.areaTourInfo.modifiedBy = 0;
    }

    const resp = await props.updateAuthDestinationServicesRenter(authId, payload);
        
        if (isFailure(resp)) {
            props.showToast('Failed to update the renter destination services info, please try again.', {
                severity: TOAST_MESSAGE_SEVERITY_ERROR
            });
            setIsLoading(false);
            return false;
        } else {
            await props.getAuthDestinationServices(authId);
            setIsLoading(false);
            return true;
        }
    };
  
  return (
    <Grid item sx={{ marginBottom: '10px' }}>
      <EditableCard
        tabs={renterPreferencesTabs}
        summaries={renterPreferencesSummaries}
        numColumns={5} 
        updateFields={updateRenterPreferences}
        isLoading={isLoading}
        hideEdit={hideEdit}
      />
    </Grid>
  );
  
};
  
const mapStateToProps = (state) => {
  return {
  };
};
  
export default compose(
  connect(mapStateToProps, {
    updateAuthDestinationServicesRenter,
    getAuthDestinationServices,
    showToast,
  }),
)(RenterPreferencesCard);